import React from 'react';
import {Spinner} from "react-bootstrap";

const ButtonPrimary = React.memo((
    {
        onclick,
        mode,
        isDisabled,
        isLoading,
        text,
        children,
        customClasses,
        spinnerClasses
    }
)=>{
    const classes = mode + " " + (customClasses ?? "")
    onclick = onclick ?? (() => {})
    isLoading = isLoading ?? false
    return(
        <button onClick={onclick} className={`button-primary ${classes}`} disabled={isDisabled}>
            <div className={`mobile-button-small ${(isLoading ? "d-none" : "d-block")}`}>
                {text}
                {children}
            </div>
            <Spinner
                className={`custom-spinner ${(spinnerClasses ?? "")} ${(isLoading ? "d-inline-block" : "d-none")}`}
                animation='border' />
        </button>
    )
})


export default ButtonPrimary